/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BulkFamilyUpdateRequest

Properties:
  override: boolean
  type: string (required)
  familyIds: array (required)
  updates: object (required)
*/

var BulkFamilyUpdateRequest = (function () {
  function validateBulkFamilyUpdateRequest (arg) {
    // Validate override
    if (arg.override && !(typeof arg.override === 'boolean')) {
      throw new Error('BulkFamilyUpdateRequest.override: Wrong type: Got \'' + (typeof arg.override) + '\', but expected: \'boolean\'')
    }
    // Validate type
    if (!arg.type) {
      throw new Error('BulkFamilyUpdateRequest.type: Missing property')
    }
    if (arg.type && !(typeof arg.type === 'string')) {
      throw new Error('BulkFamilyUpdateRequest.type: Wrong type: Got \'' + (typeof arg.type) + '\', but expected: \'string\'')
    }
    // Validate familyIds
    if (!arg.familyIds) {
      throw new Error('BulkFamilyUpdateRequest.familyIds: Missing property')
    }
    if (arg.familyIds && !(Array.isArray(arg.familyIds))) {
      throw new Error('BulkFamilyUpdateRequest.familyIds: Wrong type: Got \'' + (typeof arg.familyIds) + '\', but expected: \'array\'')
    }
    // Validate updates
    if (!arg.updates) {
      throw new Error('BulkFamilyUpdateRequest.updates: Missing property')
    }
    if (arg.updates && !(typeof arg.updates === 'object')) {
      throw new Error('BulkFamilyUpdateRequest.updates: Wrong type: Got \'' + (typeof arg.updates) + '\', but expected: \'object\'')
    }
  }
  function buildBulkFamilyUpdateRequest (arg) {
    var BulkFamilyUpdateRequest = arg
    // Complete override
    // Expected Type: boolean
    BulkFamilyUpdateRequest.override = BulkFamilyUpdateRequest.override || false
    // Complete type
    // Expected Type: string
    BulkFamilyUpdateRequest.type = BulkFamilyUpdateRequest.type || ''
    // Complete familyIds
    // Expected Type: array
    BulkFamilyUpdateRequest.familyIds = BulkFamilyUpdateRequest.familyIds || []
    // Complete updates
    // Expected Type: object
    BulkFamilyUpdateRequest.updates = BulkFamilyUpdateRequest.updates || {}
    // Complete updates.price
    // Expected Type: object
    BulkFamilyUpdateRequest.updates.price = BulkFamilyUpdateRequest.updates.price || {}
    // Complete updates.designers
    // Expected Type: array
    BulkFamilyUpdateRequest.updates.designers = BulkFamilyUpdateRequest.updates.designers || []
    // Complete updates.contractNumbers
    // Expected Type: array
    BulkFamilyUpdateRequest.updates.contractNumbers = BulkFamilyUpdateRequest.updates.contractNumbers || []
    // Complete updates.tags
    // Expected Type: array
    BulkFamilyUpdateRequest.updates.tags = BulkFamilyUpdateRequest.updates.tags || []
    // Complete updates.styleNames
    // Expected Type: array
    BulkFamilyUpdateRequest.updates.styleNames = BulkFamilyUpdateRequest.updates.styleNames || []
    // Complete updates.familyDisplayNames
    // Expected Type: array
    BulkFamilyUpdateRequest.updates.familyDisplayNames = BulkFamilyUpdateRequest.updates.familyDisplayNames || []
    return BulkFamilyUpdateRequest
  }
  return {
    validate: validateBulkFamilyUpdateRequest,
    build: buildBulkFamilyUpdateRequest
  }
})()

module.exports = BulkFamilyUpdateRequest
